<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage delivery option</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Label">
        <b-input
            type="text"
            v-model="label"
            placeholder="e.g. Today morning, 10 AM - 12 PM"
            required>
        </b-input>
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field label="Start time">
            <b-timepicker
                v-model="startTime"
                placeholder="Click to select..."
                icon="clock"
                hour-format="12">
            </b-timepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field label="End time">
            <b-timepicker
                v-model="endTime"
                placeholder="Click to select..."
                icon="clock"
                hour-format="12">
            </b-timepicker>
          </b-field>
        </div>
      </div>
      <b-field label="Close time">
        <b-timepicker
            v-model="closeTime"
            placeholder="Click to select..."
            icon="clock"
            hour-format="24">
        </b-timepicker>
      </b-field>
      <b-field label="Express delivery charge" v-if="isExpress">
        <b-input
          type="text"
          v-model.number="expressDeliveryCharge"
          placeholder="e.g. 40"
          >
        </b-input>
      </b-field>
      <div class="columns mt-1">
        <div class="column">
          <b-switch v-model="active">Active</b-switch>        
        </div>
        <div class="column">
          <b-switch v-model="isExpress">Express</b-switch>        
        </div>
        <div class="column">
          <b-switch v-model="isToday">Today</b-switch>        
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageDeliveryOption">Save</button>
    </footer>
  </div>
</template>

<script>
import moment from 'moment';
import DeliveryOptionsService from './service';

export default {
  name: 'manageDeliveryOption',

  props: ['city', 'option'],

  created() {
    if (this.option.docId) {
      let {
        docId,
        label,
        startTime,
        endTime,
        closeTime,
        isExpress,
        isToday,
        active,
        expressDeliveryCharge
      } = this.option;

      this.docId = docId;
      this.label = label;
      this.startTime = moment(startTime, 'HH:mm').toDate();
      this.endTime = moment(endTime, 'HH:mm').toDate();
      this.closeTime = moment(closeTime, 'HH:mm').toDate();
      this.isExpress = isExpress;
      this.isToday = isToday;
      this.active = active;
      this.expressDeliveryCharge = expressDeliveryCharge;
    }
  },

  data() {
    return {
      isLoading: false,
      docId: null,
      label: null,
      startTime: null,
      endTime: null,
      closeTime: null,
      isExpress: false,
      isToday: false,
      active: false,
      expressDeliveryCharge: null
    };
  },

  methods: {
    manageDeliveryOption() {
      this.isLoading = true;

      DeliveryOptionsService.manage(
        this.city,
        this.docId,
        this.label,
        this.startTime,
        this.endTime,
        this.closeTime,
        this.isExpress,
        this.isToday,
        this.active,
        this.expressDeliveryCharge
      ).then(() => {
        this.isLoading = false;
        this.$toast.open('Saved successfully');
        this.$emit('close');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/cities/DeliveryOptions/ManageDeliveryOption.vue